import { APIS } from '~constants/apis';
import { useLocalStorage } from '~hooks/index';
import sendRequest from '~utils/sendRequest';

interface Tokens {
  access: string;
  refresh: string;
}

export const refreshToken = async () => {
  const { appName, userData, updateUserData } = useLocalStorage();

  await sendRequest<Tokens>({
    url: APIS.TOKEN_REFRESH,
    method: 'post',
    data: { refresh: userData?.tokens?.refresh },
    thenFunction: (res) => {
      updateUserData(res.data);
      window.location.reload();
    },
    catchFunction: () => {
      localStorage.removeItem(appName);
      window.location.replace('/login');
    }
  });
};
